import React from 'react';
import { Box, Typography } from 'vindi-ds-components';

function CepSearchLink() {
  return (
    <Box mb='2rem'>
      <Typography variant='caption'>
        Não sabe o CEP?{' '}
        <a href='https://buscacepinter.correios.com.br/app/endereco/index.php?t'>
          Pesquisar nos correios
        </a>
      </Typography>
    </Box>
  );
}

export default CepSearchLink;
